module.exports = __webpack_public_path__ + "img/hktcmbg.705a4201.png";